import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { billingService } from '@/services/billingService';

export function useBillingOverview(period?: string) {
  return useQuery({
    queryKey: ['admin', 'billing', 'overview', period],
    queryFn: () => billingService.getOverview(period),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useBillingEvents(params?: {
  page?: number;
  limit?: number;
  type?: string;
  status?: string;
}) {
  return useQuery({
    queryKey: ['admin', 'billing', 'events', params],
    queryFn: () => billingService.getEvents(params),
    staleTime: 1000 * 30, // 30 seconds
  });
}

export function useRefund() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ paymentIntentId, amount, reason }: { paymentIntentId: string; amount: number; reason?: string }) =>
      billingService.refund(paymentIntentId, amount, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'billing'] });
    },
  });
}
